import React from 'react'
import PropTypes from 'prop-types'
import NotAvailable from '../organisms/NotAvailable'
import WithPolicy from './WithPolicy'

function PolicyAuthorization ({ policy, children }) {
  return (
    <WithPolicy policy={policy} fallback={<NotAvailable />}>
      {children}
    </WithPolicy>
  )
}

PolicyAuthorization.propTypes = {
  policy: PropTypes.string,
  children: PropTypes.node
}

export default PolicyAuthorization
